import styled from 'styled-components';
import { baseTheme } from '../../global/styles/theme';

export const ModalWindowContainer = styled('div')`
  background-color: ${baseTheme.colors.white};
  overflow: hidden;
  position: fixed;
  width: max-content;
  z-index: 300;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -10%);
  border-radius: 8px;
  box-shadow: 0 4px 10px rgb(144 154 170 / 30%);

  .modal-window {
    padding: 0 64px 56px 64px;
    margin-bottom: 20px;
    max-height: 90vh;
    min-height: 200px;
    min-width: 200px;
    overflow: auto;
    transform: translate(0%, 0%);
  }

  @media only screen and (max-width: 550px) {
    top: 0;
    left: 0;
    transform: none;
    width: 100%;
    height: 100%;

    .modal-window {
      margin-bottom: 0;
      padding: 0;
      max-width: 100vw;
      max-height: 100vh;
    }
  }
`;

export const ModalWindowContainer100 = styled('div')`
  background-color: ${baseTheme.colors.white};
  overflow: hidden;
  position: fixed;
  width: max-content;
  z-index: 1000;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -10%);
  border-radius: 8px;
  box-shadow: 0 4px 10px rgb(144 154 170 / 30%);

  .modal-window {
    padding: 0 64px 56px 64px;
    margin-bottom: 20px;
    max-height: 90vh;
    overflow: auto;
    transform: translate(0%, 0%);
  }

  @media only screen and (max-width: 550px) {
    top: 0;
    left: 0;
    transform: none;
    width: 100%;
    height: 100%;

    .modal-window {
      padding: 0;
    }
  }
`;

export const ModalWindowContent = styled('div')`
  padding: 0 64px 56px 64px;
  margin-bottom: 20px;
  max-height: 90vh;
  overflow: auto;
  transform: translate(0%, 0%);

  @media only screen and (max-width: 550px) {
    padding: 0;
    max-width: 100vw;
    transform: none;
  }
`;

export const ModalWindowHeader = styled('div')`
  padding: 16px;
  display: flex;
  justify-content: flex-end;

  img {
    cursor: pointer;
  }

  @media only screen and (max-width: 550px) {
    max-width: 100vw;
  }
`;

export const ModalWindowBackdrop = styled('div')`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 290;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  background-color: ${baseTheme.colors.primary};
  opacity: 0.3;
`;

export const ModalCloseIconContainer = styled('div')``;
